import { Modal } from 'antd'
import styled from 'styled-components'

const StyledHotkeyModal = styled(Modal)`
  width: 900px !important;
`

export default StyledHotkeyModal
